let csrfToken = sessionStorage.getItem('xingtun.csrf') ?? '';

interface ApiEnvelope<T> {
  data: T;
  meta: { request_id: string };
}

interface ApiErrorBody {
  error?: {
    code?: string;
    message?: string;
    request_id?: string;
  };
}

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly code: string,
    public readonly requestId?: string,
    public readonly status?: number,
  ) {
    super(message);
  }
}

export function setCsrfToken(token: string): void {
  csrfToken = token;
  if (token) sessionStorage.setItem('xingtun.csrf', token);
  else sessionStorage.removeItem('xingtun.csrf');
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = (init.method ?? 'GET').toUpperCase();
  const headers = new Headers(init.headers);
  if (init.body && !headers.has('Content-Type')) headers.set('Content-Type', 'application/json');
  if (!['GET', 'HEAD', 'OPTIONS'].includes(method) && csrfToken) {
    headers.set('x-csrf-token', csrfToken);
  }
  const response = await fetch(path, { ...init, headers, credentials: 'include' });
  const payload = (await response.json().catch(() => ({}))) as ApiEnvelope<T> & ApiErrorBody;
  if (!response.ok) {
    throw new ApiError(
      payload.error?.message ?? `请求失败 (${response.status})`,
      payload.error?.code ?? 'REQUEST_FAILED',
      payload.error?.request_id,
      response.status,
    );
  }
  return payload.data;
}

export function jsonBody(value: unknown): Pick<RequestInit, 'body'> {
  return { body: JSON.stringify(value) };
}
